import * as Yup from 'yup';

// Croatian OIB validation helper
const isValidOib = (oib: string) => {
  if (!/^\d{11}$/.test(oib)) return false;

  let a = 10;

  for (let i = 0; i < 10; i++) {
    const digit = parseInt(oib[i], 10);
    a = a + digit;
    a = a % 10;
    if (a === 0) a = 10;
    a = (a * 2) % 11;
  }

  let check = 11 - a;
  if (check === 10) check = 0;

  return check === parseInt(oib[10], 10);
};

export const R1InvoiceValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required('Required'),
  address: Yup.string().trim().required('Required'),
  rootCountryId: Yup.number().required('Required'),
  oib: Yup.string()
    .trim()
    .length(11, 'Max character length is 11')
    .matches(/^\d+$/, 'OIB must contain only numbers')
    .when('rootCountryId', {
      is: (rootCountryId: number) => rootCountryId === 1,
      then: Yup.string()
        .required('Required')
        .test('valid-oib', 'Invalid OIB', value => (value ? isValidOib(value) : false)),
      otherwise: Yup.string().nullable(),
    }),
  vat: Yup.string()
    .trim()
    .when('rootCountryId', {
      is: (rootCountryId: number) => rootCountryId !== 1,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }),
  partnerTypeId: Yup.number().nullable(),
});

export interface IReservationR1InvoiceInfo {
  name: string;
  address: string;
  city: string;
  postalCode: string;
  rootCountryId: number;
  email: string;
  oib: string;
  vat: string;
  taxNumber: string;
  partnerTypeId: number;
  isPdv: boolean;
}

export type TPayloadCreateInvoice = {
  option: string;
  businessYear?: number;
  paymentId?: string;
};
